// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CRIO_SOLUTION_START_MODULE_CART */
/* CRIO_SOLUTION_END_MODULE_CART */
#add-new-btn {
    text-transform: none;
    font-weight: 700;
    margin: 1rem 0;
}

.address-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem;
    margin: 1rem 0;
    border-radius: 5px;
    cursor: pointer;
}

.shipping-container {
    padding: 2rem 1rem;
}

.selected {
    border: 1px solid #00A278;
    background-color: #E9F5E1;
}

.not-selected {
    border: 1px solid #ddd;
}

p {
    color: #3C3C3C;
}

@media screen and (min-width: 768px) {
    .shipping-container {
        padding: 2rem 4rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Checkout.css"],"names":[],"mappings":"AAAA,oCAAoC;AACpC,kCAAkC;AAClC;IACI,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ","sourcesContent":["/* CRIO_SOLUTION_START_MODULE_CART */\n/* CRIO_SOLUTION_END_MODULE_CART */\n#add-new-btn {\n    text-transform: none;\n    font-weight: 700;\n    margin: 1rem 0;\n}\n\n.address-item {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 1rem;\n    margin: 1rem 0;\n    border-radius: 5px;\n    cursor: pointer;\n}\n\n.shipping-container {\n    padding: 2rem 1rem;\n}\n\n.selected {\n    border: 1px solid #00A278;\n    background-color: #E9F5E1;\n}\n\n.not-selected {\n    border: 1px solid #ddd;\n}\n\np {\n    color: #3C3C3C;\n}\n\n@media screen and (min-width: 768px) {\n    .shipping-container {\n        padding: 2rem 4rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
